var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"audio-widget"},[_c('audio',{attrs:{"src":_vm.src,"id":_vm.refId,"controls":""}}),_c('figcaption',[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))])])])}
var staticRenderFns = []

export { render, staticRenderFns }